import React from 'react';
import PropTypes from 'prop-types';
import {Loading, Modal, ModalBody, ModalContainer, ModalFooter, ModalHeader, ModalTitle, ModalOverlay, Button, Toast} from "spectre-react/dist/cjs";
import {Timeline, TimelineItem, TimelineLeft, TimelineIcon, TimelineContent, Icon} from "spectre-react/dist/cjs";
import {doApproveReportForAll, doApproveReportFor, fetchApprovalDoc} from "../../api";
import {REPORT_APPROVAL_STAGE} from "../shared/constants";
import {dmyHmFmt, dmyHmsFmt} from "../shared/utils";
import ErrorToast from "../shared/ErrorToast";


class ModalApproval extends React.PureComponent {
    static propTypes = {
        onAfterApprove: PropTypes.func.isRequired,
    }

    defaultState = {
        active: false,
        reportId: undefined,

        fetchState: 0, fetchError: null,
        docFound: undefined,
        isOverallApproved: undefined, isHistoryEmpty: undefined,
        history: undefined, status: undefined, createdAt: undefined,

        submitState: 0, submitError: null,
    }

    state = {...this.defaultState};

    fetchReportApprovalDoc = async () => {
        try {
            this.setState({fetchState: 1, fetchError: null});
            const reportId = this.state.reportId;

            const {docFound, status, history, createdAtISO} = await fetchApprovalDoc(reportId);
            this.setState({docFound, status, history});

            if (docFound) {
                const isHistoryEmpty = Object.values(history).every(items => items.length === 0);
                const isOverallApproved = Object.values(status).every(({stage}) => stage === REPORT_APPROVAL_STAGE.APPROVED);
                const createdAt = createdAtISO ? new Date(createdAtISO) : undefined;  // when docFound is false, createdAtISO is undefined
                this.setState({isHistoryEmpty, isOverallApproved, createdAt});
            }

            this.setState({fetchState: 2, fetchError: null});
        } catch (error) {
            console.error('fetchReportApprovalDoc', error);
            this.setState({fetchState: 0, fetchError: error.message});
        }
    }

    openModal = (reportId) => this.setState({active: true, reportId}, this.fetchReportApprovalDoc);

    closeModal = () => this.setState(this.defaultState);

    doApproveForEngineer = async (ev) => {
        try {
            let timelineEl = ev.currentTarget;
            while (!timelineEl.classList.contains('timeline'))
                timelineEl = timelineEl.parentElement;

            const engineerId = timelineEl.dataset.engineerId;
            const reportId = this.state.reportId;

            this.setState({submitState: 1, submitError: null});
            await doApproveReportFor(reportId, engineerId);
            await this.fetchReportApprovalDoc();
            this.setState({submitState: 0});

            if (this.props.onAfterApprove)
                await this.props.onAfterApprove();
        } catch (error) {
            this.setState({submitState: 0, submitError: error.message})
        }
    };

    doApproveForAll = async () => {
        try {
            const reportId = this.state.reportId;

            this.setState({submitState: 1, submitError: null});
            await doApproveReportForAll(reportId);
            this.closeModal();
            this.setState({submitState: 0});

            if (this.props.onAfterApprove)
                await this.props.onAfterApprove();
        } catch (error) {
            this.setState({submitState: 0, submitError: error.message})
        }
    };

    renderHistoryCol(engineerId) {
        const {
            status, history: _history, createdAt,
            submitState
        } = this.state;

        const {currentUser} = this.props;

        const {stage, nextAssigneeId, engineerName, nextAssigneeName} = status[engineerId];
        const isCurrentUserAssigned = nextAssigneeId === currentUser._id;
        const assigneeName = isCurrentUserAssigned ? 'Вы' : nextAssigneeName;

        const isApproved = stage === REPORT_APPROVAL_STAGE.APPROVED;
        const isSubmitting = submitState === 1;

        const history = _history[engineerId];

        return (
            <div key={engineerId}>
                <div className="h5 text-center mb-4">{engineerName}</div>

                <Timeline data-engineer-id={engineerId}>
                    <TimelineItem>
                        <TimelineLeft>
                            <TimelineIcon/>
                        </TimelineLeft>

                        <TimelineContent>
                            <div className="d-flex space-between">
                                <span className="mr-3">Репорт создан</span>
                                <span className="text-bold mr-4">{dmyHmsFmt(createdAt)}</span>
                            </div>
                        </TimelineContent>
                    </TimelineItem>
                    {history.map(({authorId, authorName, comment, timestampISO}, index) => (
                        <TimelineItem final={(index === history.length - 1) /* isLast */ && isApproved}
                                      key={authorId + timestampISO}>
                            <TimelineLeft>
                                <TimelineIcon bg="success">
                                    <Icon icon="check"/>
                                </TimelineIcon>
                            </TimelineLeft>

                            <TimelineContent>
                                <div className="d-flex space-between">
                                    <span className="mr-3">{authorName}</span>
                                    <span className="text-bold mr-4">{dmyHmsFmt(new Date(timestampISO))}</span>
                                </div>
                                {comment && <div>{comment}</div>}
                            </TimelineContent>
                        </TimelineItem>
                    ))}
                    {!isApproved && (
                        <TimelineItem>
                            <TimelineLeft>
                                <TimelineIcon bg="warning">
                                    <Icon icon="more-horiz"/>
                                </TimelineIcon>
                            </TimelineLeft>

                            <TimelineContent>
                                <div className="d-flex space-between">
                                    <span className="mr-3">{assigneeName}</span>
                                    <span className="text-bold mr-4">?</span>
                                </div>
                                {isCurrentUserAssigned && (
                                    <div className="mt-2">
                                         <Button success onClick={this.doApproveForEngineer} loading={isSubmitting}>Одобрить</Button>
                                    </div>
                                )}
                            </TimelineContent>
                        </TimelineItem>
                    )}
                </Timeline>
            </div>
        )
    }

    renderContent() {
        const {fetchState, fetchError, docFound, status, history, isOverallApproved, isHistoryEmpty} = this.state;

        if (fetchState === 0)
            return null;

        if (fetchState === 1)
            return <Loading large />

        if (fetchError)
            return <ErrorToast>{fetchError}</ErrorToast>;

        if (docFound === false) {
            return (
                <div className="text-justify">
                    Репорт был создан до внедрения механизма и потому ручного одобрения не требует / одобрен априори.
                </div>
            );
        }

        if (docFound === true && isOverallApproved && isHistoryEmpty) {
            return (
                <div className="text-justify">
                    Цепочка одобрения на момент создания репорта была пустой, поэтому репорт был одобрен автоматически.
                </div>
            );
        }

        const engineerIds = Object.keys(status);

        return (
            <div>
                <div>
                    Одобрить репорт для начисления оплаты труда технику? Отмена действия не предусмотрена.<br/><br/>
                </div>

                <div className="d-flex">
                    {engineerIds.map(engineerId => this.renderHistoryCol(engineerId))}
                </div>
            </div>
        );
    }

    getCurrentUserAssignmentsCount() {
        const {docFound, status} = this.state;
        const {currentUser} = this.props;

        if (!docFound)
            return;

        return Object.entries(status)
            .map(([, obj]) => obj.nextAssigneeId === currentUser._id)
            .reduce((acc, val) => acc + Number(val), 0);
    }

    render() {
        if (!this.state.active) return null;

        const {docFound, submitState, submitError} = this.state;

        const assignmentsCount = this.getCurrentUserAssignmentsCount();
        const showSubmitButton = docFound === true && assignmentsCount > 0;
        const isSubmitting = submitState === 1;

        return (
            <Modal active id="report-approval-modal" className="modal-fit-content">
                <ModalOverlay onClick={this.closeModal}/>
                <ModalContainer>
                    <ModalHeader>
                        <Button className="btn-clear float-right" onClick={this.closeModal}/>
                        <ModalTitle className="h5">Одобрение репорта</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        {this.renderContent()}
                    </ModalBody>
                    <ModalFooter>
                        {submitError && <Toast error className="text-left mb-2">{submitError}</Toast>}

                        {showSubmitButton && <Button success loading={isSubmitting} onClick={this.doApproveForAll}>Одобрить ({assignmentsCount})</Button>}
                        <Button link className="ml-2" onClick={this.closeModal}>Закрыть</Button>
                    </ModalFooter>
                </ModalContainer>
            </Modal>
        )
    }
}


export default ModalApproval;